module.exports = __webpack_public_path__ + "img/landing-escalations.bf1abd9.png";